import Image from 'next/future/image';
import { CtaLink } from '@/components/Cta/Cta';
import BuybackImage from '@/public/images/buyback/au_buyback.png';
import RightArrowIcon from '@/public/images/right-arrow.svg';

export default function SellPhoneForCash() {
  return (
    <div className="relative mx-auto flex flex-col-reverse flex-wrap items-center rounded border bg-teal-500 p-4 sm:p-8 lg:flex-row">
      <div className="w-full text-center md:mb-0 md:max-w-[600px] lg:w-5/6 lg:text-left xl:max-w-[100%]">
        <h2 className="text-xl font-extrabold sm:text-3xl lg:mb-2  ">
          SELL YOUR PHONE WITH REEBELO.
        </h2>
        <p className="mb-7 text-base sm:mb-12 sm:text-2xl lg:text-[29px]">
          Best Prices. Fast Payment. Effortless.
        </p>
        <div className="block w-full">
          <CtaLink
            href="https://sell.reebelo.com.au/"
            className="relative inline-flex w-full max-w-[420px] items-center justify-center rounded-md border-0 bg-gray-700 py-4 px-6 text-base text-white focus:outline-none sm:text-xl sm:font-semibold lg:max-w-[500px] lg:py-6 lg:text-2xl"
          >
            Sell My Phone for Cash
            <div className="absolute right-6 h-[20px] sm:static sm:ml-8 sm:h-[26px]">
              <Image
                height={16}
                width={8}
                src={RightArrowIcon}
                alt="right-arrow"
              />
            </div>
          </CtaLink>
        </div>
      </div>
      <div className="w-full lg:w-5/6">
        <div className="right-0 mx-auto mb-4 w-40 sm:mb-0 md:w-80 lg:absolute lg:-bottom-2">
          <Image
            height={181}
            width={320}
            alt="Reebelo Buyback"
            src={BuybackImage}
          />
        </div>
      </div>
    </div>
  );
}
